import { MouseEventHandler, useEffect, useState } from 'react';
import Button from 'react-bootstrap/esm/Button';
import Col from 'react-bootstrap/esm/Col';
import Row from 'react-bootstrap/esm/Row';
import { useDispatch, useSelector } from 'react-redux';
import { Link, useNavigate, useParams } from 'react-router-dom';
import { AppDispatch, RootState } from '../../app/store';
import LoadingIndicator from '../loading/LoadingIndicator';
import { listMeasurements } from '../measurements/measurementsSlice';
import { useAuth } from '../signin/auth';
import EditGoal from './EditGoal';
import { getGoal, selectGoal, writeGoal } from './goalSlice';
import { GoalUpdate } from './types';

type RouteGoalCloneParams = {
  goalID: string;
}

const RouteGoalClone = () => {
  let { goalID } = useParams<keyof RouteGoalCloneParams>() as RouteGoalCloneParams;

  const auth = useAuth();
  const dispatch = useDispatch<AppDispatch>();
  const navigate = useNavigate();
  const goal = useSelector((state: RootState) => selectGoal(state));
  const goalStatus = useSelector((state: RootState) => state.goal.status)
  const goalError = useSelector((state: RootState) => state.goal.error)
  const [goalState, setGoalState] = useState<GoalUpdate>({});

  useEffect(() => {
    if (auth.authToken) {
      dispatch(listMeasurements({
        authToken: auth.authToken,
      }));
    }
  }, [dispatch, auth.authToken]);

  useEffect(() => {
    if (auth.authToken) {
      dispatch(getGoal({
        authToken: auth.authToken,
        goalID: goalID,
        includeEntries: false,
      }));
    }
  }, [dispatch, auth.authToken, goalID]);

  useEffect(() => {
    if ((goalStatus === 'succeeded' || goalStatus === 'failed') && !goal) {
      navigate("/goals");
    }
  }, [goal, navigate, goalStatus]);

  const onSaveGoalClicked: MouseEventHandler<HTMLButtonElement> = async (evt) => {
    if (auth.authToken) {
      const result = await dispatch(writeGoal({
        authToken: auth.authToken,
        goal: goalState,
      })).unwrap();
      console.log("Wrote goal!", result);
      navigate(`/goal/${result?.goal.id}/edit`)
    } else {
      console.log('No auth token!');
    }
  }

  return (
    <>
      <Row className="justify-content-end">
        <Col sm="auto">
          <Link to={`/goal/${goalID}`}>
            <Button variant='secondary'>Cancel</Button>
          </Link>
        </Col>
      </Row>
      <Row className="mt-3">
        <Col>
          <div>
            {goalStatus === 'loading' && <LoadingIndicator />}
            {goalError && <div>{goalError}</div>}
            {goal &&
              <EditGoal cloneGoal goal={goal} goalState={goalState} setGoalState={setGoalState}>
                <Row>
                  <Col className="col-sm-auto">
                    <button type="button" className="btn btn-primary" onClick={onSaveGoalClicked} disabled={goalStatus === 'loading'}>
                      Create goal
                    </button>
                  </Col>
                  <Col className="col-sm-auto ml-auto">
                  </Col>
                </Row>
              </EditGoal>
            }
          </div>
        </Col>
      </Row>
    </>
  );
};

export default RouteGoalClone;
